export const ERC_6492_MAGIC_VALUE = "0x6492649264926492649264926492649264926492649264926492649264926492";
//# sourceMappingURL=constants.js.map